export const newsPerPage = 25;
